module.exports = {
      id: "prayer-header-usage",
      viewBox: "0 0 300 193",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#prayer-header",
      toString: function () {
        return this.url;
      }
    }